module.exports = __webpack_public_path__ + "static/media/app-store-badge.cddb0f38.svg";